<template>
  <div class="col">
    <BaseIndex
      ref="baseIndex"
      :loading="loading"
      :pageLoading="pageLoading"
      :table-headers="tableHeaders"
      :table-items="allOutboundNfeTaxationRules"
      :modelNameSingular="modelNameSingular"
      :modelNamePlural="modelNamePlural"
    >
      <!-- <template slot="new">
        <New
          @entry-created="entryCreated"
        />
      </template> -->

      <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <!-- <template slot="delete" slot-scope="{ item }">
        <Delete
          :entry="item"
          @entry-destroyed="entryDeleted"
        />
      </template> -->
    </BaseIndex>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import Edit from "./edit.vue";

export default {
  data() {
    return {
      allOutboundNfeTaxationRules: [],
      loading: true,
      pageLoading: false,
      tableHeaders: [
        { text: "#", align: "left", sortable: true, value: "id" },
        { text: "Grupo de Tributação", align: "left", sortable: true, value: "taxationGroup.name" },
        { text: "NCM", align: "left", sortable: true, value: "taxationGroup.ncm.code" },
        { text: "Regime Tributário", align: "left", sortable: true, value: "taxRegimeTypeName" },
        { text: "Destino da Operação", align: "left", sortable: true, value: "operationDestinationTypeName" },
        { text: "Status", align: "left", sortable: true, value: "status" },
        { text: "Ações", value: "action", sortable: false }
      ]
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Regra de Tributação"
    },
    modelNamePlural: {
      type: String,
      default: "Regras de Tributações"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    Edit: Edit,
  },
  created() {
    this.loadServerEntries(true);
  },
  methods: {
    loadServerEntries: function(cached) {
      this.loading = true;
      this.$apollo
        .query({
          query: ALL_OUTBOUND_NFE_TAXATION_RULES_QUERY,
          fetchPolicy: cached ? "cache-first" : "network-only",
          variables: {
            taxationGroupId: this.$route.params.taxationGroupId
          }
        })
        .then(response => {
          this.allOutboundNfeTaxationRules = response.data.accountGlobalSharedContext.allOutboundNfeTaxationRules;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries(false);
      this.$refs.baseIndex.showConfirmationMessage("Registro atualizado com sucesso!");
    },
    entryCreated: function(){
      this.loadServerEntries(false);
      this.$refs.baseIndex.showConfirmationMessage("Registro criado com sucesso!");
    },
    entryDeleted: function(){
      this.loadServerEntries(false);
      this.$refs.baseIndex.showConfirmationMessage("Registro removido com sucesso!");
    },
  }
};

const ALL_OUTBOUND_NFE_TAXATION_RULES_QUERY = gql `
  query ($taxationGroupId: ID) {
    accountGlobalSharedContext{
      allOutboundNfeTaxationRules(taxationGroupId: $taxationGroupId) {
        id
        taxRegimeTypeName
        operationDestinationTypeName
        status
        statusKey
        statusValue
        taxationGroup{
          name
          ncm {
            code
          }
        }
      }
    }
  }
`
</script>

<style scoped></style>
